import { MealTime } from "@/clients/models/MealTime";
import { UnderlinedTextButton } from "@/components/button/underlined-text-button";
import { useGetAlternativeFilterOptions } from "@/hooks/requests/plan/use-get-alternative-filter-options";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";
import { memo } from "react";
import { useLocation } from "react-router";

interface NoMealsEmptyStateProps {
  mealTime: MealTime;
  selectedSubFilter: string;
  refetch: () => void;
}
export const NoMealsEmptyState = memo(function NoMealsEmptyState({
  mealTime,
  selectedSubFilter,
  refetch,
}: NoMealsEmptyStateProps) {
  const { allSubOptionMapping } = useGetAlternativeFilterOptions(mealTime, "v2");
  const searchParams = useSearchParams();
  const navigation = useIonRouter();
  const location = useLocation();
  const resetSearchParams = () => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete("filter");
    newSearchParams.delete("subFilter");
    newSearchParams.delete("fromBrand");
    newSearchParams.delete("search");
    navigation.push(`${location.pathname}`, "forward", "replace");
  };
  const selectedOption = allSubOptionMapping[selectedSubFilter];

  if (selectedSubFilter !== "") {
    return (
      <div className={cn("flex h-full w-full flex-col items-center gap-4 px-8 py-17 text-center")}>
        <h1 className={cn(textVariants.headline, "uppercase")}>
          nothing for {selectedOption?.name ?? selectedSubFilter}
        </h1>
        <UnderlinedTextButton
          onClick={resetSearchParams}
          className={cn(textVariants.title3, "text-screen-gs-1 leading-11")}
        >
          View all
        </UnderlinedTextButton>
      </div>
    );
  }
  return (
    <div className={cn("flex h-full w-full flex-col items-center gap-4 px-8 py-17 text-center")}>
      <h1 className={cn(textVariants.headline, "uppercase")}>
        Sorry, I can’t find
        <br /> suitable meals for you
      </h1>
      <UnderlinedTextButton
        onClick={refetch}
        className={cn(textVariants.title3, "text-screen-gs-1 leading-11")}
      >
        Retry
      </UnderlinedTextButton>
    </div>
  );
});
